import { useEffect, useState } from 'react'
import { useMatch } from 'react-router-dom'

import { PropsMapHook } from 'client/components/Map/types'

export const useHasGallery = (props: PropsMapHook): boolean => {
  const { mapRef } = props

  const [hasGallery, setHasGallery] = useState<boolean>(false)

  const matchCluster = useMatch(`/projects/:projectName/gallery`)
  const matchStory = useMatch(`/projects/:projectName/stories/:storyName`)

  useEffect(() => {
    setHasGallery(Boolean(matchStory) || Boolean(matchCluster))

    const timeout = setTimeout(() => {
      mapRef.current?.resize()
    }, 10)

    return () => {
      clearTimeout(timeout)
    }
  }, [mapRef, matchCluster, matchStory])

  return hasGallery
}
